import jsPDF from 'jspdf'
import domtoimage from '../tools/dom-to-image';
export default  {
    methods: {
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },
        async exportAllItems(items,customName="export"){
            window.scrollTo(0,0);
            await this.sleep(400)
            let doc = new jsPDF('', 'pt','a3',true);
            doc.setFontSize(8)
            let page = 1;
            let y =20;
            let ratio=1.0*782.28;
            for (let item of items){
                if(y>1000){
                    doc.text(600,1160, customName+' page ' + page);
                    doc.addPage()
                    page=page+1;
                    y=30
                } else if (items.indexOf(item)===items.length-1){
                    doc.text(600,1160, customName+' page ' + page);
                }
                let img=null;
                if (typeof item === 'string'){
                    let target=document.querySelector(document.querySelector(item))
                    let imgURL = await domtoimage.toJpeg(target, {
                        quality: 0.95 ,
                        bgcolor:"#FFFFFF"
                    })
                    doc.addImage(imgURL, 'JPEG', 30, y, ratio, ratio/target.clientWidth*target.clientHeight, undefined, "FAST")
                }  else if (item.$refs.plotly){
                    img =  await item.$refs.plotly.toImage()
                    doc.addImage(img, 'JPEG', 30, y,
                        ratio,
                        ratio/item.$refs.plotly.$refs.container.$el.clientWidth*item.$refs.plotly.$refs.container.$el.clientHeight,"","FAST"
                    )
                    y=y+ratio/item.$refs.plotly.$refs.container.$el.clientWidth*item.$refs.plotly.$refs.container.$el.clientHeight+20;
                } else if (item.$refs.container){
                    img =  await item.toImage()
                    doc.addImage(img, 'JPEG', 30, y,
                        ratio,
                        ratio/item.$refs.container.$el.clientWidth*item.$refs.container.$el.clientHeight,"","FAST"
                    )
                    y=y+ratio/item.$refs.container.$el.clientWidth*item.$refs.container.$el.clientHeight+20;
                }
            }
            doc.save(customName+'.pdf')
        }
    }
};